interface ISatellite {
  track: (name: string) => void;
}

function ecomAdobeEventDefined() {
  return (
    typeof window !== "undefined" &&
    (window as unknown as Record<string, unknown>).adobeEvent
  );
}

const AnalyticsService = {
  emitEvent: (name: string, data: Record<string, string>) => {
    if (ecomAdobeEventDefined()) {
      // do nothing?
    }
  },
  emitCustomEvent: (name: string) => {
    if (typeof window.CustomEvent === "function") {
      document.body.dispatchEvent(new CustomEvent(name));
    }
  },
  satelliteTrack(name: string) {
    if (typeof (window as any)._satellite !== "undefined") {
      const satellite: ISatellite = (window as any)._satellite;
      satellite.track(name);
    }
  },
};

export default AnalyticsService;
